import { render, staticRenderFns } from "./DocumentVersionsPage.vue?vue&type=template&id=5d725cac"
import script from "./DocumentVersionsPage.vue?vue&type=script&lang=ts"
export * from "./DocumentVersionsPage.vue?vue&type=script&lang=ts"
import style0 from "./DocumentVersionsPage.vue?vue&type=style&index=0&id=5d725cac&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports